import {
  GET_ACCOUNT_NOTES,
  GET_ACCOUNT_NOTES_FAILURE,
  GET_ACCOUNT_NOTES_SUCCESS,
} from '../actions'
import { INITIAL_ACCOUNT_NOTES_STATE } from '../containers/contexts/search/SearchContext'
import { AccountNotesState } from '../types'
import { AccountNote } from '../types/AccountNote'

export const accountNotesReducer = (
  state: AccountNotesState = INITIAL_ACCOUNT_NOTES_STATE,
  { type, accountNotes = [] }: { type: string; accountNotes?: AccountNote[] }
): AccountNotesState => {
  switch (type) {
    case GET_ACCOUNT_NOTES:
      return { loadingAccountNotes: true, accountNotes: [] }
    case GET_ACCOUNT_NOTES_SUCCESS:
      return { loadingAccountNotes: false, accountNotes }
    case GET_ACCOUNT_NOTES_FAILURE:
      return { ...state, loadingAccountNotes: false }
    default:
      return state
  }
}
